export const getLastParts = (coordinate: string, parts: number): string => {
  if (parts <= 0) {
    return '';
  }

  const regex = /([_.-])/;
  const partsArray = coordinate.split(regex);
  const start = Math.max(0, partsArray.length - (2 * parts - 1));

  return partsArray.slice(start).join('');
};

// @TODO careful, there is no check if coordinateA is a prefix of coordinateB
export const subCoordinate = (coordinateA: string, coordinateB: string): string => {
  const partCount = coordinateA.split(/[_\-.]/).filter((part) => part !== '').length;
  const partsArrayCurrentCoordinate = coordinateB.split(/[_\-.]/).filter((part) => part !== '');
  const partCountCurrentCoordinate = partsArrayCurrentCoordinate.length;
  const partLengthAreaToCurrent = partCountCurrentCoordinate - partCount;
  const partLength = partLengthAreaToCurrent > 0 ? partLengthAreaToCurrent : 1;
  return getLastParts(coordinateB, partLength);
};

export interface Color {
  r: number;
  g: number;
  b: number;
  a: number;
}

export interface ColorStop {
  color: Color;
  position: number;
}

export const colorToRgba = (color: Color): string => {
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
};

export const createLinearGradient = (angle: number, colorStops: ColorStop[]): string => {
  const gradientStops = colorStops.map((stop) => `${colorToRgba(stop.color)} ${stop.position}%`).join(', ');
  return `linear-gradient(${angle}deg, ${gradientStops})`;
};

export const upperCaseFirst = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1);
